import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/sign-up-bonus/chest/free.png';
import _imports_1 from '@/assets/img/sign-up-bonus/click-arrow.png';
const _withScopeId = n => (_pushScopeId("data-v-66671100"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "daliy-bonus-page"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-bg"
}, null, -1));
const _hoisted_4 = {
  class: "signin-list free"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "signin-item-content"
};
const _hoisted_7 = {
  class: "signin-day"
};
const _hoisted_8 = {
  class: "signin-status"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "chest-img",
  src: _imports_0
}, null, -1));
const _hoisted_10 = {
  key: 0,
  class: "sign-btn flex justify-center signed"
};
const _hoisted_11 = {
  key: 1,
  class: "sign-btn flex justify-center"
};
const _hoisted_12 = {
  key: 2,
  class: "signin-item-cover"
};
const _hoisted_13 = {
  key: 0,
  class: "tip-wrap"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tip-img",
  src: _imports_1
}, null, -1));
const _hoisted_15 = {
  class: "divider-wrap"
};
const _hoisted_16 = {
  class: "signin-list level"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "signin-item-content"
};
const _hoisted_19 = {
  class: "signin-day border-text"
};
const _hoisted_20 = {
  class: "signin-status"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 2,
  class: "sign-btn border-text flex justify-center"
};
const _hoisted_24 = {
  key: 3,
  class: "sign-btn border-text flex justify-center"
};
const _hoisted_25 = {
  key: 4,
  class: "signin-item-cover"
};
const _hoisted_26 = {
  key: 0,
  class: "tip-wrap"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tip-img",
  src: _imports_1
}, null, -1));
const _hoisted_28 = {
  key: 0,
  class: "process-wrap"
};
const _hoisted_29 = {
  class: "process-bar-wrap"
};
const _hoisted_30 = {
  key: 0,
  class: "process-percent border-text"
};
const _hoisted_31 = {
  key: 1,
  class: "process-percent border-text"
};
const _hoisted_32 = {
  class: "right-info-wrap"
};
const _hoisted_33 = {
  class: "right-reward-info free"
};
const _hoisted_34 = {
  class: "info-title"
};
const _hoisted_35 = {
  class: "info-content"
};
const _hoisted_36 = {
  class: "right-reward-info level"
};
const _hoisted_37 = {
  class: "info-title"
};
const _hoisted_38 = {
  class: "info-content"
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = {
  key: 1
};
const _hoisted_41 = {
  key: 2
};
import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePopupStore, useReddotStore } from '@/store';
import { querySignUpActivity, queryBattlePassActivity, signUp, signBattlePass } from '@/api';
export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const MyToast = inject('myToast');
    const {
      t
    } = useI18n();
    const popupStore = usePopupStore();
    const redDotStore = useReddotStore();
    const activityList = ref([]);
    const battlePass = ref({});
    onMounted(() => {
      fetchSignUpActivity();
      fetchBattlePassActivity();
    });
    const fetchSignUpActivity = () => {
      querySignUpActivity().then(res => {
        activityList.value = res.data || [];
      });
    };
    const fetchBattlePassActivity = () => {
      queryBattlePassActivity().then(res => {
        battlePass.value = res.data || {};
      });
    };
    const doSignUp = item => {
      if (item.status === 'signing') {
        signUp({
          activityId: item.activityId
        }).then(res => {
          var _res$data;
          fetchSignUpActivity();
          popupStore.showRewards(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.rewards);
          // 处理外部红点数量展示
          redDotStore.signUp();
        });
      } else if (item.status === 'unable') {
        MyToast({
          message: t('msg.notSigninDate')
        });
      }
    };
    const doSignBattlePass = item => {
      if (item.status === 'signing') {
        signBattlePass({
          activityId: item.activityId
        }).then(res => {
          var _res$data2;
          fetchBattlePassActivity();
          popupStore.showRewards(res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.rewards);
          // 处理外部红点数量展示
          redDotStore.signUp();
        });
      } else if (item.status === 'unable') {
        MyToast({
          message: t('msg.notSigninDate')
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => {
          var _battlePass$value$lev, _battlePass$value$cur, _battlePass$value$nex, _battlePass$value$nex2;
          return [_createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(_component_van_image, {
            class: "close-icon",
            src: require('@/assets/img/common/popup-close.png'),
            onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
          }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]]), _hoisted_3, _createElementVNode("div", {
            class: _normalizeClass(`popup-content level${battlePass.value.level > 5 ? 5 : battlePass.value.level}`)
          }, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityList.value, item => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: item.day,
              class: _normalizeClass(`signin-item ${item.status == 'signing' ? 'is-today' : ''}`),
              onClick: $event => doSignUp(item)
            }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('common.day').toUpperCase()) + " " + _toDisplayString(item.day), 1)]), _createElementVNode("div", _hoisted_8, [item.status == 'signed' ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "signed-img",
              src: require('@/assets/img/sign-up-bonus/signed.png')
            }, null, 8, ["src"])) : item.status == 'unable' ? (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              class: "lock-img",
              src: require('@/assets/img/sign-up-bonus/lock.png')
            }, null, 8, ["src"])) : _createCommentVNode("", true)]), _hoisted_9, item.status == 'signed' ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('common.claimed').toUpperCase()) + "!", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('common.claim').toUpperCase()), 1)), item.status == 'unable' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : _createCommentVNode("", true)]), item.status == 'signing' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.clickToClaim').toUpperCase()), 1), _hoisted_14])) : _createCommentVNode("", true)], 10, _hoisted_5)), [[_directive_audio]]);
          }), 128))]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_van_image, {
            class: "light-img",
            src: require('@/assets/img/sign-up-bonus/light.png')
          }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(battlePass.value.battlePassVOList, item => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: item.day,
              class: _normalizeClass(`signin-item ${item.status == 'signing' ? 'is-today' : ''}`),
              onClick: $event => doSignBattlePass(item)
            }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('common.day').toUpperCase()) + " " + _toDisplayString(item.day), 1)]), _createElementVNode("div", _hoisted_20, [item.status == 'signed' ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "signed-img",
              src: require('@/assets/img/sign-up-bonus/signed.png')
            }, null, 8, ["src"])) : item.status == 'unable' ? (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              class: "lock-img",
              src: require('@/assets/img/sign-up-bonus/level-lock.png')
            }, null, 8, ["src"])) : _createCommentVNode("", true)]), item.img ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "chest-img",
              src: item.img
            }, null, 8, _hoisted_21)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "chest-img",
              src: require(`@/assets/img/sign-up-bonus/chest/${battlePass.value.level > 5 ? 5 : battlePass.value.level}.png`)
            }, null, 8, _hoisted_22)), item.status == 'signed' ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('common.claimed').toUpperCase()) + "!", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('common.claim').toUpperCase()), 1)), item.status == 'unable' ? (_openBlock(), _createElementBlock("div", _hoisted_25)) : _createCommentVNode("", true)]), item.status == 'signing' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.clickToClaim').toUpperCase()), 1), _hoisted_27])) : _createCommentVNode("", true)], 10, _hoisted_17)), [[_directive_audio]]);
          }), 128))]), battlePass.value.level ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [battlePass.value.exp ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "process-bar",
            style: _normalizeStyle(`width: ${Math.floor(battlePass.value.exp / battlePass.value.nextExp * 100)}%`)
          }, null, 4)) : _createCommentVNode("", true)]), battlePass.value.nextLevel ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$filter.outputAmount(battlePass.value.exp)) + " / " + _toDisplayString(_ctx.$filter.outputAmount(battlePass.value.nextExp) || '-'), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('signUp.max')), 1)), _createVNode(_component_van_image, {
            class: "star-img",
            src: require(`@/assets/img/sign-up-bonus/star/${battlePass.value.level > 5 ? 5 : battlePass.value.level}.png`)
          }, null, 8, ["src"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_van_image, {
            class: "info-img",
            src: require('@/assets/img/sign-up-bonus/star/free.png')
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.free').toUpperCase()), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.rewards').toUpperCase()), 1)]), _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('signUp.freeRewardInfo').format({
            day: activityList.value.length
          }).toUpperCase()), 1)]), _createVNode(_component_van_image, {
            class: "divider-line",
            src: require('@/assets/img/sign-up-bonus/short-light.png')
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_36, [battlePass.value.level ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            class: "info-img",
            src: require(`@/assets/img/sign-up-bonus/star/${battlePass.value.level > 5 ? 5 : battlePass.value.level}.png`)
          }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, _toDisplayString((_battlePass$value$lev = battlePass.value.levelStr) === null || _battlePass$value$lev === void 0 ? void 0 : _battlePass$value$lev.toUpperCase()), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.rewards').toUpperCase()), 1)]), _createElementVNode("div", _hoisted_38, [!battlePass.value.nextLevel ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.$t('signUp.levelRewardInfo.max').format({
            level: battlePass.value.levelStr,
            day: (_battlePass$value$cur = battlePass.value.currentLevel) === null || _battlePass$value$cur === void 0 || (_battlePass$value$cur = _battlePass$value$cur.battlePassVOList) === null || _battlePass$value$cur === void 0 ? void 0 : _battlePass$value$cur.length
          }).toUpperCase()), 1)) : battlePass.value.nextLevel.level == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t('signUp.levelRewardInfo.init').format({
            amount: _ctx.$filter.outputAmount(battlePass.value.nextRecharge),
            level: battlePass.value.nextLevelStr,
            day: (_battlePass$value$nex = battlePass.value.nextLevel) === null || _battlePass$value$nex === void 0 || (_battlePass$value$nex = _battlePass$value$nex.battlePassVOList) === null || _battlePass$value$nex === void 0 ? void 0 : _battlePass$value$nex.length
          }).toUpperCase()), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.levelRewardInfo.common').format({
            amount: _ctx.$filter.outputAmount(battlePass.value.nextRecharge),
            level: battlePass.value.nextLevelStr,
            day: (_battlePass$value$nex2 = battlePass.value.nextLevel) === null || _battlePass$value$nex2 === void 0 || (_battlePass$value$nex2 = _battlePass$value$nex2.battlePassVOList) === null || _battlePass$value$nex2 === void 0 ? void 0 : _battlePass$value$nex2.length
          }).toUpperCase()), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('signUp.levelRewardInfo.tip')), 1)]))])])])], 2)])];
        }),
        _: 1
      })]);
    };
  }
};